import { PageSection } from '../../../../../common/styles/page';
import { Button, Dropdown, Input } from 'semantic-ui-react';
import React from 'react';

interface TaskManagementFiltersProps {
  searchFilter: string;
  setSearchFilter: (value: string) => void;
  categoryFilter: string;
  setCategoryFilter: (value: string) => void;
  getTaskCategories: () => string[];
  getFilteredTasks: () => any[];
  getAllTasksUnified: () => any[];
  fetchAllTasks: () => void;
  loading: boolean;
  extraControls?: React.ReactNode;
}

const TaskManagementFilters = (props: TaskManagementFiltersProps) => {
  const {
    searchFilter,
    setSearchFilter,
    categoryFilter,
    setCategoryFilter,
    getTaskCategories,
    getFilteredTasks,
    getAllTasksUnified,
    fetchAllTasks,
    loading,
    extraControls,
  } = props;

  return (
    <PageSection>
    <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <label>Search:</label>
        <Input
          placeholder="Search tasks..."
          value={searchFilter}
          onChange={(_, { value }) => setSearchFilter(value)}
          style={{ width: '200px' }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <label>Category:</label>
        <Dropdown
          placeholder="All Categories"
          selection
          value={categoryFilter}
          onChange={(_, { value }) => setCategoryFilter(value as string)}
          options={[
            { key: '', text: 'All Categories', value: '' },
            ...getTaskCategories().map(cat => ({ key: cat, text: cat, value: cat })),
          ]}
        />
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ color: '#666', fontSize: '0.9em' }}>
              {loading
                ? 'Loading...'
                : `Showing ${getFilteredTasks().length} of ${getAllTasksUnified().length} tasks`}
            </span>
        <Button
          icon="refresh"
          size="mini"
          onClick={fetchAllTasks}
          loading={loading}
          title="Refresh tasks"
          style={{ width: '38px', height: '35px', borderRadius: '8px' }}
        />
        {extraControls && <div style={{ marginLeft: '8px' }}>{extraControls}</div>}
      </div>
    </div>
    </PageSection>
  );
};

export default TaskManagementFilters;
